'use client';

import { useDispatch, useSelector } from 'react-redux';

import Link from 'next/link';

import Button from '@/components/elements/button';
import { useTranslation } from '@/i18n/client';
import { toggleForm } from '@/store/event-payment/event-payment.actions';
import { getIsFormOpen } from '@/store/event-payment/event-payment.selectotrs';
import { EventDetails } from '@/types/events';
import { WithLang } from '@/types/general';
import { TicketSelectOption } from '@/types/tickets';

interface Props {
    event: EventDetails;
    ticketOptions: TicketSelectOption[];
}

export default function BuyButton(props: WithLang<Props>) {
    const { t } = useTranslation(props.lang, 'common');

    const dispatch = useDispatch();
    const isFormOpen = useSelector(getIsFormOpen);

    const isSoldOut = props.event.tickets.length > 0 && !props.event.tickets.some((item) => item.status === 'active');
    const withTickets =
        props.ticketOptions?.length > 0 &&
        +props.event.visit_price > 0 &&
        props.event.status === 'scheduled' &&
        props.event.payment_currency.length > 0;

    return (
        <div className="flex flex-col items-start gap-2">
            <h6 className="text-base font-medium">{t('common.buyTicketsOrSignUp')}</h6>
            {props.event.book_link && (
                <Link
                    className="btn-accent w-[60%] text-center text-black"
                    href={props.event.book_link}
                    target="_blank"
                >
                    {t('register')}
                </Link>
            )}
            {withTickets && (
                <Button
                    disabled={isFormOpen}
                    className="btn-accent w-[60%] text-center text-black"
                    title={t('common.buy')}
                    onClick={() => dispatch(toggleForm())}
                />
            )}
            {isSoldOut && (
                <button className="btn-accent w-[60%] text-center text-black" disabled={isSoldOut}>
                    {t('common.soldOut')}
                </button>
            )}
        </div>
    );
}
